module.exports = __webpack_public_path__ + "img/icon_table_price_wghn.ca02352c.svg";